import { CaseMap, PatientCaseContent, patientCaseContentSchema } from '@llx/common';
import { useMemo } from 'react';

import { useListPatientCasesWithContentQuery } from '@/@generated/codegen/API';
import { parseCaseAssets } from '@/utils/helpers/parseCaseAssets';

export function parseStringifiedPatientCaseContent(content: string): PatientCaseContent {
  return parseCaseAssets(patientCaseContentSchema.parse(JSON.parse(content)));
}

function usePatientCaseContent(patientCaseIds: string[]) {
  const casesQuery = useListPatientCasesWithContentQuery({
    variables: {
      where: {
        id: {
          in: patientCaseIds,
        },
      },
    },
    skip: patientCaseIds.length === 0,
  });

  const caseMap = useMemo(() => {
    if (!casesQuery.data) return {};
    return casesQuery.data.listPatientCases.edges.reduce((acc, curr) => {
      acc[curr.node.id] = parseStringifiedPatientCaseContent(curr.node.stringifiedContent);
      return acc;
    }, {} as CaseMap);
  }, [casesQuery.data]);

  return {
    caseMap: caseMap,
    isCaseMapLoading: casesQuery.loading || Object.keys(caseMap).length === 0,
  };
}

export default usePatientCaseContent;
